/**
 * The four player-facing verbs, one label and glyph each, used by every panel
 * and message so a word always means the same thing:
 * Train = make a new unit, Upgrade = change a unit's type,
 * Rank up = veterancy, Level up = a building or city level.
 */
export const VERBS = {
  train: { label: 'Train', glyph: '⊕' },
  upgrade: { label: 'Upgrade', glyph: '⬆' },
  rankUp: { label: 'Rank up', glyph: '★' },
  levelUp: { label: 'Level up', glyph: '⇧' },
} as const;

export type Verb = keyof typeof VERBS;

/** "⬆ Upgrade": the glyph and label together. */
export function verbText(verb: Verb): string {
  return `${VERBS[verb].glyph} ${VERBS[verb].label}`;
}
